import React, { Fragment } from "react";
import { useState } from "react";
import { Row, Col, Card, Table, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import Loader from "../../../common/Loader";
import NoData from "../../../common/NoData";
import Pagination from "../../../common/Pagination/Pagination";
import { Translate } from "../../../Enums/Tranlate";
import CardItem from "./CardItem";
import { useNavigate } from "react-router-dom";
import RoleService from "../../../../services/RoleService";

const Permission = () => {
	const [data, setData] = useState([]);
	const [item, setItem] = useState({});
	const [hasData, setHasData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const roleService = new RoleService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.admin?.admin_roles?.includes(data);
	const navigate = useNavigate();
	const search = useSelector((state) => state.auth.search);

	return (
		<div>
			<div className="mb-4">
				<div className="search-card d-flex justify-content-between align-items-center">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang].roles}
						</span>
					</div>
					<div className="add-department">
						{
							<Button
								variant="primary"
								className="me-2 h-75"
								onClick={() => navigate("/roles/add_role")}>
								<i className="la la-plus mx-1"></i>
								{Translate[lang]?.add} {Translate[lang]?.role}
							</Button>
						}
					</div>
				</div>
			</div>

			<Row>
				<Col lg={12}>
					<Card>
						<div
							className={`${hasData === 0 ? "text-center" : "table-style"} `}>
							{loading && (
								<div style={{ height: "400px" }}>
									<Loader />
								</div>
							)}

							{hasData === 1 && !loading && (
								<Table responsive>
									<thead>
										<tr className="text-center">
											<th>
												<strong>{Translate[lang]?.name}</strong>
											</th>
											{/* <th>
												<strong>{Translate[lang]?.created_on}</strong>
											</th> */}
											{/* <th>
												<strong>{Translate[lang]?.status}</strong>
											</th> */}
											<th className="text-center">
												<strong>{Translate[lang]?.action}</strong>
											</th>
										</tr>
									</thead>

									<tbody className="table-body">
										{data?.map((item, index) => {
											return (
												<CardItem
													index={index}
													key={index}
													item={item}
													setItem={setItem}
													setShouldUpdate={setShouldUpdate}
												/>
											);
										})}
									</tbody>
								</Table>
							)}
							{hasData === 0 && <NoData />}
							<Pagination
								setData={setData}
								service={roleService}
								shouldUpdate={shouldUpdate}
								setHasData={setHasData}
								setLoading={setLoading}
								search={search}
							/>
						</div>
					</Card>
				</Col>
			</Row>
		</div>
	);
};

export default Permission;
